import { InputFocusDirective } from './input-focus.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [InputFocusDirective,],
  exports: [InputFocusDirective,],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
